<template>
  <div class="content">
    <div style="width: 100%;height: 2rem;background-color: #fff">
      <div style="width: 100%;height: .8rem;background-color: #87CEFA;text-align: center;line-height: .8rem;color: #fff">
        {{jcreport.检查项目}}
      </div>
      <div style="width: 100%;height: 1.2rem">
        <el-row>
          <el-col :span="11">
            <div style="height: .6rem;line-height: .7rem;text-align: center">姓名</div>
            <div style="height: .6rem;line-height: .5rem;text-align: center;color: #87CEFA">{{$storage.get('patient').clinic_patient_name}}</div>
          </el-col>
          <el-col :span="2">
            <div style="height: 1.2rem;width: 100%;text-align: center;font-size: .4rem;color: #999999;line-height: 1.2rem">|</div>
          </el-col>
          <el-col :span="11">
            <div style="height: .6rem;line-height: .7rem;text-align: center">年龄</div>
            <div style="height: .6rem;line-height: .5rem;text-align: center;color: #87CEFA">{{$storage.get('patient').QrAge}}岁</div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div style="width: 90%;margin: 0 auto">
      <div style="width: 100%;height: .8rem;background-color: #87CEFA;line-height: .8rem;text-align: center;color: #fff">影像诊断</div>
      <div style="width: 94%;margin:0 auto;background-color: #fff;line-height: .6rem;padding: 0 3%">&nbsp&nbsp{{jcreport.影像诊断}}</div>
    </div>
    <div style="width: 90%;margin: 0 auto">
      <div style="width: 100%;height: .8rem;background-color: #87CEFA;line-height: .8rem;text-align: center;color: #fff">影像描述</div>
      <div style="width: 94%;margin:0 auto;background-color: #fff;line-height: .6rem;padding: 0 3%">&nbsp&nbsp{{jcreport.影像描述 }}</div>
    </div>
  </div>
</template>

<script>
  import {getreportjclist} from '../../api/index'
    export default {
      data(){
        return{
          jcreport:{}
        }
      },
      created() {
        //修改标题
        document.title = '检查详情'
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        getreportjclist({
          startdate:this.$route.query.startdate,
          enddate:this.$route.query.enddate,
          name:this.$storage.get('patient').clinic_patient_name,
          cardnum:this.$storage.get('patient').clinic_num,
          healthcardno:this.$storage.get('patient').healthCardId,
          patientid:this.$storage.get('patient').patient_id,
        }).then(res=>{
          loading.close();
          let index = res.Data.findIndex(e=>{return  e.申请单ID==this.$route.query.index})
          this.jcreport = res.Data[index]
        })
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: .3rem;
  }
  .noCard{
    width: 7.5rem;
    height: 3.5rem;
    padding: 2rem 0 4rem 0;
    background-color: #ffffff;
  }
  .noCard .noCard-img{
    width: 2.6rem;
    height: 2.6rem;
    margin: 0 auto;
  }
  .noCard .noCard-img img{
    width: 100%;
    height: 100%;
  }
  .noCard .noCard-text{
    margin-top: .3rem;
    font-size: .32rem;
    line-height: .32rem;
    width: 100%;
    height: .32rem;
    text-align: center;
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/jcreport.vue